import { styled } from '$utils/theme'
import { rem } from 'polished'
import { Block } from '$views/components'

export const StyledCardElement = styled(Block)`
  .StripeElement {
    color: ${p => p.theme.colors.darkGrey};
    height: ${p => rem(p.theme.sizes.large)};
    border: 1px solid ${p => p.theme.colors.lightGrey};
    border-radius: ${rem(30)};
    padding: ${p => rem(p.theme.sizes.mini)};
    background-color: ${p => p.theme.colors.white};
  }

  .StripeElement--focus {
    border-color: ${p => p.theme.colors.darkGrey};
    caret-color: ${p => p.theme.colors.darkGrey};
    outline: none;
  }
`



// WEBPACK FOOTER //
// ./src/views/PaymentDetails/components/CreditCardForm.style.ts